<div class="hr-calendar-month-picker" test-id="hr-calendar-month-picker">
  <div class="hr-calendar-month-picker__year">
    <button type="button"
            class="btn btn-plain-default hr-calendar-month-picker__year-btn"
            test-id="hr-calendar-picker-previous-year"
            [attr.aria-label]="'HR_CALENDAR.previous_year' | translate"
            (click)="changeYear(-1)">
      <em class="fa fa-light fa-chevron-left" aria-hidden="true"></em>
    </button>
    <span class="hr-calendar-month-picker__year-label" aria-live="polite" test-id="hr-calendar-picker-year">
      {{ pickerYear }}
    </span>
    <button type="button"
            class="btn btn-plain-default hr-calendar-month-picker__year-btn"
            test-id="hr-calendar-picker-next-year"
            [attr.aria-label]="'HR_CALENDAR.next_year' | translate"
            (click)="changeYear(1)">
      <em class="fa fa-light fa-chevron-right" aria-hidden="true"></em>
    </button>
  </div>
  <div class="hr-calendar-month-picker__months">
    <button *ngFor="let month of months; trackBy: trackMonth"
            type="button"
            class="btn hr-calendar-month-picker__month"
            test-id="hr-calendar-picker-month"
            [ngClass]="isSelected(month.index) ? 'btn-fill-primary' : 'btn-plain-default'"
            [attr.aria-label]="month.fullLabel + ' ' + pickerYear"
            [attr.aria-pressed]="isSelected(month.index)"
            (click)="selectMonth(month.index)">
      {{ month.shortLabel }}
    </button>
  </div>
</div>

